
import {Component, Prop, Vue} from 'vue-property-decorator';
import vModal from './vModal.vue';
import {mapState} from "vuex";
import {LocalizationState} from "@/store/modules/LocalizationModule";

@Component({
  components: {
    vModal,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    })
  }
})
export default class vCopyRecipeModal extends Vue {
  localizationState: LocalizationState;
  newRecipeName: string = "";

  @Prop() isRecipe: boolean;
  @Prop() recipeName: string;
  @Prop() showCopyRecipeModal : boolean;

  get translations() {
    return this.localizationState.translations;
  }

  closeCopyRecipeModal(){
    this.$emit("on-cancel");
  }

  saveCopiedRecipe(){
    this.$validator.validateAll("recipe").then((result) => {
      if (result) {
        this.$emit("save-copied-recipe", this.newRecipeName);
      }
    });
  }
}
  